import { render } from "./PortalSeguimiento.vue?vue&type=template&id=04e007c4&scoped=true"
import script from "./PortalSeguimiento.vue?vue&type=script&lang=js"
export * from "./PortalSeguimiento.vue?vue&type=script&lang=js"

import "./PortalSeguimiento.vue?vue&type=style&index=0&id=04e007c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e007c4"]])

export default __exports__